import React from "react";
import { Container, Typography, CardContent, Card } from "@mui/material";

const NotFound: React.FC = () => {
  return (
    <Container maxWidth="md">
      <Card>
        <CardContent>
          <Typography variant="h5" style={{marginBottom:"30px"}}>Page not found</Typography>
        </CardContent>
      </Card>
    </Container>
  );
};

export default NotFound;